<svg xmlns="http://www.w3.org/2000/svg" width="14.586" height="10.586"><path d="M5.293 10.586L.002 5.293l1.292-1.292 4 4 8-8 1.294 1.294-9.293 9.291z"/></svg>
